import styled from "styled-components"

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 30px;
    margin: 20px;

    h3 {
        color: var(--lightGrey);
    }
`
